import type { CanvasSession, PhaseCode } from "./schema";
import { findPhase } from "./schema";

export interface FieldSummary {
  name: string;
  code?: string;
  label: string;
  answer: string;
  score: number | null;
  gapFlagged: boolean;
  gapNote: string;
}

export function phaseFieldSummaries(session: CanvasSession, phase: PhaseCode): FieldSummary[] {
  const phaseDef = findPhase(phase);
  const state = session.phases[phase];
  return phaseDef.fields.map((f) => {
    const a = state.fields[f.name];
    return {
      name: f.name,
      code: f.code,
      label: f.label,
      answer: a?.answer ?? "(unanswered)",
      score: a?.score ?? null,
      gapFlagged: a?.gapFlagged ?? false,
      gapNote: a?.gapNote ?? "",
    };
  });
}
